import { render } from "./SettingsColumn.vue?vue&type=template&id=5c4a8a22&scoped=true"
import script from "./SettingsColumn.vue?vue&type=script&lang=js"
export * from "./SettingsColumn.vue?vue&type=script&lang=js"

import "./SettingsColumn.vue?vue&type=style&index=0&id=5c4a8a22&scoped=true&lang=css"

import exportComponent from "/usr/share/node/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4a8a22"]])

export default __exports__